import Cookies from "js-cookie";

export const isCookieSet = (cookieName: string): boolean => {
  try {
    const cookie = Cookies.get(cookieName);
    return cookie === "true";
  } catch {
    return false;
  }
};

export const isTrackEventLoggingCookieSet = (): boolean =>
  isCookieSet("track_event_logging_enabled");
export const isPriceTestingEnabledCookieSet = (): boolean =>
  isCookieSet("price_testing_enabled");
